import React from "react";
import styled from "styled-components";
import PretendardText from "../atoms/text/mainText";

const SelectBoxValue = ({
  style,
  subMenuStyle,
  isSmall,
  isMiddle,
  isOpen,
  wrapperHandler,
  selectedValue,
  placeholder,
  selectedValueSetterFunc,
  itemList,
  disabled,
}) => {
  return (
    <div
      style={{
        position: "relative",
        width: isSmall ? "93px" : isMiddle ? "134px" : "338px",
        ...style,
      }}
    >
      <SelectBoxWrapper
        onClick={() => {
          if (disabled) {
            return;
          }

          wrapperHandler(!isOpen);
        }}
        style={{
          cursor: "pointer",
          border: isOpen && "1px solid #27beff",
        }}
        isSmall={isSmall}
        isMiddle={isMiddle}
      >
        <PretendardText
          style={{
            color: selectedValue ? "#aaa" : "rgba(181, 181, 181, 0.5)",
            fontSize: "15px",
            fontWeight: "400",
            lineHeight: "21.25px",
          }}
        >
          {selectedValue
            ? itemList.find((item) => item.value === selectedValue).title
            : placeholder}
        </PretendardText>
        <img
          className={isOpen ? "rotate" : "rotate-back"}
          style={{
            width: "18px",
            height: "18px",
          }}
          src="/assets/admin/icons/ico_select_arrow_down.svg"
          alt="펼치기"
        />
      </SelectBoxWrapper>
      {isOpen ? (
        <SubMenuWrapper
          isSmall={isSmall}
          isMiddle={isMiddle}
          className="custom-scrollbar"
          style={{
            ...subMenuStyle,
          }}
        >
          {itemList.map((item, index) => {
            return (
              <SubMenuTextWrapper
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: isSmall ? "73px" : isMiddle ? "124px" : "318px",
                  height: "42px",
                  padding: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  selectedValueSetterFunc(item.value);
                  wrapperHandler(false);
                }}
              >
                <PretendardText
                  style={{
                    color:
                      selectedValue === item.value
                        ? "#aaa"
                        : "var(--text3, rgba(181, 181, 181, 0.5))",
                    fontSize: "15px",
                    fontWeight: "500",
                    lineHeight: "21.5px",
                  }}
                >
                  {item.title}
                </PretendardText>
                {selectedValue === item.value ? (
                  <img
                    style={{
                      width: "18px",
                      height: "18px",
                    }}
                    src="/assets/admin/icons/ico_select_checked.svg"
                    alt=""
                  />
                ) : null}
              </SubMenuTextWrapper>
            );
          })}
        </SubMenuWrapper>
      ) : null}
    </div>
  );
};

export default SelectBoxValue;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: ${(props) =>
    props.isSmall ? "93px" : props.isMiddle ? "134px" : "338px"};
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 15px;
  border-radius: 4px;
  border: 1px solid var(--outline1, rgba(255, 255, 255, 0.12));
  background: transparent;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: ${(props) =>
    props.isSmall ? "93px" : props.isMiddle ? "134px" : "338px"};
  min-height: 42px;
  max-height: 356px;
  border-radius: 3px;
  background: #313233;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 53px;
  right: 0;
  padding: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 5;
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: "flex";
  justify-content: "space-between";
  align-items: "center";
  width: "318px";
  height: "42px";
  padding: "10px";
  cursor: "pointer";
  border-radius: 3px;
`;
